import React from 'react';
import { IconProps } from '../types';

export const MarketResearchIcon = ({ color }: IconProps) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_8890_7584)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.8907 14.3221C22.8907 10.7499 19.9948 7.85405 16.4226 7.85405C12.8504 7.85405 9.95452 10.7499 9.95452 14.3221C9.95452 17.8944 12.8504 20.7902 16.4226 20.7902C19.9948 20.7902 22.8907 17.8944 22.8907 14.3221ZM17.4439 10.015V13.3009H20.7297C20.3461 11.6769 19.0678 10.3986 17.4439 10.015ZM20.7297 15.3434H16.4226C15.8586 15.3434 15.4013 14.8862 15.4013 14.3221V10.015C13.4495 10.4761 11.9971 12.2295 11.9971 14.3221C11.9971 16.7663 13.9785 18.7477 16.4226 18.7477C18.5153 18.7477 20.2687 17.2952 20.7297 15.3434Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.4439 0.705114C17.4439 0.141079 16.9866 -0.316162 16.4226 -0.316162C15.8586 -0.316162 15.4013 0.141079 15.4013 0.705114V2.40724H4.16729C3.60325 2.40724 3.14601 2.86448 3.14601 3.42852V24.1945H1.44388C0.879849 24.1945 0.422607 24.6517 0.422607 25.2158C0.422607 25.7798 0.879849 26.237 1.44388 26.237H11.2336L7.53024 29.9404C7.13141 30.3392 7.13141 30.9859 7.53024 31.3847C7.92908 31.7835 8.57571 31.7835 8.97455 31.3847L14.1222 26.237H15.4013V29.3009C15.4013 29.8649 15.8586 30.3221 16.4226 30.3221C16.9866 30.3221 17.4439 29.8649 17.4439 29.3009V26.237H18.723L23.8707 31.3847C24.2695 31.7835 24.9161 31.7835 25.315 31.3847C25.7138 30.9859 25.7138 30.3392 25.315 29.9404L21.6116 26.237H31.4013C31.9654 26.237 32.4226 25.7798 32.4226 25.2158C32.4226 24.6517 31.9654 24.1945 31.4013 24.1945H29.6992V3.42852C29.6992 2.86448 29.242 2.40724 28.6779 2.40724H17.4439V0.705114ZM5.18856 4.4498V24.1945H27.6566V4.4498H5.18856Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0_8890_7584">
                <rect width="32" height="32" fill={color} />
            </clipPath>
        </defs>
    </svg>
);
